import React from "react";
import "./TermsConditions.css";
const Privacy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Privacy Policy</h1>
        <div className="terms-section">
          <h2>Introduction</h2>
          <p>
            MAS Mobility Service is committed to protecting your privacy and
            safeguarding your personal information. This Privacy Policy explains
            how we collect, use, process, store, and protect your information
            when you visit our website, use our services, or interact with our
            company.
          </p>
          <p>
            By using our website and services, you agree to the practices
            described in this Privacy Policy.
          </p>
        </div>
        <div className="terms-section">
          <h2>Information We Collect</h2>
          <p>We may collect the following personal information:</p>
          <ul>
            <li>Full Name</li>
            <li>Date of Birth</li>
            <li>Nationality</li>
            <li>Gender</li>
            <li>Country of Residence</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Residential Address</li>
            <li>National ID, Iqama, Passport, or Driving License Details</li>
            <li>Vehicle Rental Information</li>
            <li>Payment Information</li>
          </ul>
          <p>We may also collect non-personal information including:</p>
          <ul>
            <li>Browser Type</li>
            <li>Device Information</li>
            <li>IP Address</li>
            <li>Website Usage Data</li>
            <li>Communication Preferences</li>
          </ul>
        </div>
        <div className="terms-section">
          <h2>How We Use Your Information</h2>
          <ul>
            <li>Process vehicle rental reservations and bookings</li>
            <li>Verify customer identity and eligibility</li>
            <li>Deliver requested services</li>
            <li>Provide customer support</li>
            <li>Improve our website and services</li>
            <li>Send booking confirmations and notifications</li>
            <li>Conduct surveys and market research</li>
            <li>Comply with legal requirements</li>
          </ul>
        </div>
        <div className="terms-section">
          <h2>Information Sharing</h2>
          <p>
            MAS Mobility Service does not sell, rent, or trade your personal
            information.
          </p>
          <p>
            We may share information with authorized service providers,
            payment processors, legal authorities, and business partners
            involved in service delivery where necessary.
          </p>
        </div>
        <div className="terms-section">
          <h2>Consent</h2>
          <p>
            By providing your personal information, you consent to its
            collection, processing, and use as described in this Privacy Policy.
          </p>
          <p>
            You may opt out of marketing communications at any time by following
            the unsubscribe instructions included in our communications.
          </p>
        </div>
        <div className="terms-section">
          <h2>Cookies and Tracking Technologies</h2>
          <p>
            Our website may use cookies, web beacons, analytics tools, and
            similar technologies to improve functionality and user experience.
          </p>
          <p>
            You may disable cookies through your browser settings, although
            certain website features may not function properly.
          </p>
        </div>
        <div className="terms-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational security
            measures to protect your information against unauthorized access,
            disclosure, alteration, loss, or misuse.
          </p>
        </div>
        <div className="terms-section">
          <h2>Data Retention</h2>
          <p>
            We retain personal information only as long as necessary to fulfill
            business purposes, comply with legal obligations, resolve disputes,
            and enforce agreements.
          </p>
        </div>
        <div className="terms-section">
          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. MAS Mobility
            Service is not responsible for the privacy practices, content, or
            security of external websites.
          </p>
        </div>
        <div className="terms-section">
          <h2>Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age
            permitted by applicable law. We do not knowingly collect personal
            information from minors without appropriate consent.
          </p>
        </div>
        <div className="terms-section">
          <h2>Your Rights</h2>
          <ul>
            <li>Access your personal information</li>
            <li>Request corrections</li>
            <li>Request deletion of information</li>
            <li>Withdraw consent where applicable</li>
            <li>Request information about data processing</li>
          </ul>
        </div>
        <div className="terms-section">
          <h2>Changes to This Privacy Policy</h2>
          <p>
            MAS Mobility Service may update this Privacy Policy from time to
            time. Any changes will be posted on this page with an updated
            revision date.
          </p>
        </div>
        <div className="terms-section">
          <h2>Contact Us</h2>
          <p>
            MAS Mobility Service <br />
            Jeddah, Kingdom of Saudi Arabia
          </p>
          <p>
            For questions regarding this Privacy Policy, please contact our
            customer support team through the Contact Us page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;